import React from "react";
import { useTheme } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../../Assets/Images/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../Assets/Images/twitter.svg";
import { ReactComponent as LinkedInIcon } from "../../Assets/Images/linkin.svg";
import { ReactComponent as InstagramIcon } from "../../Assets/Images/instagram.svg";
import { ReactComponent as PinterestIcon } from "../../Assets/Images/pinterest.svg";
import { ReactComponent as EmailIcon } from "../../Assets/Images/emailIcon.svg";
import { ReactComponent as TelephoneIcon } from "../../Assets/Images/telephoneIcon.svg";
import { ReactComponent as AddressIcon } from "../../Assets/Images/addressIcon.svg";


const Footer = () => {
  const theme = useTheme();
  const location = useLocation();

  const handleHowItWorksClick = (e) => {
    if (location.pathname === '/aboutus') {
      e.preventDefault();
      window.location.hash = '#how-it-works';
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  };

  const handleBlogClick = (e) => {
    if (location.pathname === '/resources') {
      e.preventDefault();
      window.location.hash = '#blogs';
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  };

  return (
    <div  className="footer-sections show" style={{ backgroundColor: theme?.palette?.footer?.main }}>
      <div className="container-fluid">
        <div className="row flex-row">
          <div className="col-sm-6">
            <div className="footer-data-left">
              <div>
                <p className="footer-content-block footer-con-style" style={{ color: theme?.palette?.footer?.text }}>
                  FOOTPRINTID® is a convenient way to store and quickly access
                  important medical information like allergens, immunizations,
                  prescriptions, emergency contacts and more.
                </p>
                <div className="row flex-row moblie-view-footer-link">
                  <div className="col-md-6 footer-second-part">
                    <div className="footer-link">
                      <li>
                        <Link to="/er" style={{ color: theme?.palette?.footer?.text }}>
                          Emergency Login
                        </Link>
                      </li>
                      <li>
                        <Link to="/aboutus" style={{ color: theme?.palette?.footer?.text }}>
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/resources" style={{ color: theme?.palette?.footer?.text }}>
                          Compare Services
                        </Link>
                      </li>
                      <li>
                        <Link 
                          to="/resources#blogs" 
                          onClick={handleBlogClick}
                          style={{ color: theme?.palette?.footer?.text }}
                        >
                          Blog
                        </Link>
                      </li>
                    </div>
                  </div>
                  <div className="col-md-6 footer-second-part">
                    <div className="footer-link">
                      {/* <li>
                        <a href="/resources" target="_self" style={{ color: theme?.palette?.footer?.text }}>
                          Resources
                        </a>
                      </li> */}
                      <li>
                        <Link 
                          to="/aboutus#how-it-works" 
                          onClick={handleHowItWorksClick}
                          style={{ color: theme?.palette?.footer?.text }}
                        >
                          How it Works
                        </Link>
                      </li>
                      <li>
                        <Link to="/resources" style={{ color: theme?.palette?.footer?.text }}>
                          FAQs
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy" style={{ color: theme?.palette?.footer?.text }}>
                          Privacy Policy
                        </Link>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
              <div className="visit-pawprint-footer">
                <p className="footer-content-block" style={{ color: theme?.palette?.footer?.text }}>
                  Want a Footprint for your pet?
                </p>
                <div style={{ width: 'fit-content' }} className="visit-pawprint-footer-link">
                  <a
                    className="footer-back underline text-inner-style"
                    rel="noreferrer"
                    href="/"
                  >
                    Visit PawprintID® <img src="/assets/svg/right.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 text-right footer-mobile-view">
            <div className="footer-left-content">
              <div className="text-align-end footer-left-right">
                <div className="footer-back" style={{ color: theme?.palette?.footer?.text }}>
                  <AddressIcon width={22} height={20} fill={`${theme?.palette?.footer?.text}`} />&nbsp;
                  P.O. Box 2412 Livingston, NJ 07039
                </div>
                <div>
                  <TelephoneIcon width={22} height={20} fill={`${theme?.palette?.footer?.text}`} />
                  <a href="tel:+1(855)374-3411" className="footer-back" style={{ color: theme?.palette?.footer?.text }}>&nbsp;
                    +1(855)374-3411
                  </a>
                </div>
                <div className="image-container">

                  <div className="image-sub-container"><EmailIcon width={22} height={20} fill={`${theme?.palette?.footer?.text}`} />&nbsp;</div>
                  <a
                    href="mailto:support@footprintid.com"
                    className="underline footer-back"
                    style={{ color: theme?.palette?.footer?.text }}
                  >
                    support@footprintid.com
                  </a>
                </div>
              </div>
              <div className="social-icons-sections">
                <a
                  href="http://facebook.com/footprintid"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FacebookIcon style={{ fill: theme.palette.footer.text }} />
                </a>
                <a
                  href="http://twitter.com/footprintid"
                  target="_blank"
                  rel="noreferrer"
                >
                  <TwitterIcon style={{ fill: theme.palette.footer.text }} />
                </a>
                <a
                  href="https://www.linkedin.com/company/footprintid/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <LinkedInIcon style={{ fill: theme.palette.footer.text }} />
                </a>
                <a
                  href="https://www.instagram.com/footprint_i_d/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <InstagramIcon style={{ fill: theme.palette.footer.text }} />
                </a>
                <a
                  href="https://www.pinterest.com/FootprintId1/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <PinterestIcon style={{ fill: theme.palette.footer.text }} />
                </a>
              </div>
              <div className="footer-btn-inner">
                <div>
                  <a
                    className="footer-btn-section"
                    href="https://apps.apple.com/in/app/footprint-id/id808239013"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="assets/images/appleIcon.png" alt="" />
                  </a>
                </div>
                <div>
                  <a
                    className="footer-btn-section"
                    href="https://play.google.com/store/apps/details?id=com.footprintid.hit"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/assets/images/playStore.png" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p className="footer-bottom" style={{ color: theme?.palette?.footer?.text }}>
            &copy;{new Date().getFullYear()} Copyright FootprintID®. All Right Reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
